"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coverageThreshold = void 0;
exports.coverageThreshold = {
    coverageThreshold: {
        global: {
            branches: 70,
            functions: 70,
            lines: 70,
            statements: 70,
        }
    }
};
